import styled from "styled-components";
import colors from "../../../../css/colors";

export const Header = styled.div`
  text-align: center;
  font-weight: 300;
  font-size: 36px;
  border: none;
  margin: 0 0 48px;
`;

export const FormWrapper = styled.div`
  max-width: 330px;
  margin: auto;
  .ant-select {
    width: 100%;
    max-width: 296px;
  }
`;

export const DropdownWrapper = styled.div`
  margin: 30px auto;
`;

export const Label = styled.div`
  margin: 4px;
  font-size: 12px;
  font-weight: 300;
`;

export const LogoUploadWrapper = styled.div`
  margin: 30px 0;
  max-width: 296px;
  .header {
    font-size: 12px;
    font-weight: 300;
    margin: 4px;
    min-height: 32px;
    align-items: flex-end;
  }
`;

export const HeaderText = styled.div``;

export const RedText = styled.span`
  color: ${colors.RED};
`;

export const ServiceCodeSelectWrapper = styled.div``;

export const CreateButtonWrapper = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  margin: 32px 0 80px;
`;
